module.exports = __webpack_public_path__ + "img/set-account.1c251f8a.svg";